import React, { Component } from 'react';
import {
  Alert,
  Button,
  KeyboardAvoidingView,
  ScrollView,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from 'react-native';
import Autocomplete from './autocomplete';
import Styles from './styles';
import Config from './config';
import Hermes from './hermes';

const FlashCardsURL = `${Config.Scheme}://${Config.Domain}/flash_cards`;

export default class FlahCardsView extends Component {
  static navigationOptions = {
    title: 'Flash Cards',
  };
  constructor() {
    super();
    this.state = {
      words: null,
      choices: [],
      current: 0,
      score: 0,
      message: "",
      seconds: 30,
      cards: "10",
      source: "",
      sources: [],
      sourcesHide: false,
    };
    this._getSources = this._getSources.bind(this);
  }

  static getChoices(current, words) {
    const max = words.length
    let choices = [];
    for (let i = 0; i < 4; i++) {
      let choice = Math.floor(Math.random() * max);
      while ((choice == current) || choices.includes(choice)) {
        choice = Math.floor(Math.random() * max);
      }
      choices.push(choice)
    }
    const correct = Math.floor(Math.random() * 4);
    choices[correct] = current;
    return choices
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  async start() {
    const {cards, source} = this.state;
    try {
      const result = await Hermes.fetch(`${FlashCardsURL}?cards=${cards}&source=${source}`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        method: "GET",
      });

      const words = result.words;
      if (words.length < 5) {
        Alert.alert("More than 4 words/cards are required.")
        return;
      }
      this.setState({
        words: words,
        choices: FlahCardsView.getChoices(0, words),
        current: 0,
        score: 0,
        message: "",
        seconds: 30,
      });

      setTimeout(this.timer.bind(this), 1000)
    } catch (error) {
      Hermes.alert(error);
    }
  }

  timer() {
    if (!(this._mounted)) {
      return;
    }
    const {message, current, words, score} = this.state;
    if (message == "") {
      const seconds = this.state.seconds - 1;
      if (seconds <= 0) {
        if (current == words.length - 1) {
          this.setState({
            message: `Score: ${score}/${words.length}`,
          });
        } else {
          this.setState({
            message: "Out of time!",
          })
        }
        return;
      }
      this.setState({
        seconds: seconds,
      });
      setTimeout(this.timer.bind(this), 1000)
    }
  }

  choiceSelected(choice) {
    const {words, current, score} = this.state;
    if (choice == current) {
      const newScore = score + 1;
      if (current == words.length - 1) {
        this.setState({
          message: `Score: ${newScore}/${words.length}`,
          score: newScore,
        });
        return;
      }
      this.setState({
        message: "Correct!",
        score: newScore,
      });
      return;
    }
    if (current == words.length - 1) {
      this.setState({
        message: `Incorrect! Correct choice: ${words[current].word} Score: ${score}/${words.length}`,
        score: score,
      });
      return;
    }
    this.setState({
      message: `Incorrect! Correct choice: ${words[current].word}`,
    })
  }

  next() {
    const current = this.state.current + 1;
    if (current >= this.state.words.length) {
      this.setState({
        words: null,
      });
      return;
    }

    const words = this.state.words;
    this.setState({
      current: current,
      choices: FlahCardsView.getChoices(current, words),
      message: "",
      seconds: 30,
    });

    setTimeout(this.timer.bind(this), 1000)
  }

  async _getSources(query) {
    this.setState({
      source: query,
    });

    try {
      const result = await Hermes.fetch(`${Config.Scheme}://${Config.Domain}/sources?query=${query}`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        method: "GET",
      });

      const sources = result.sources
      sources.unshift(this.state.source);
      this.setState({
        sources: sources.filter((v,i) => sources.indexOf(v) == i),
        sourcesHide: false,
      });
    } catch(error) {
      Hermes.alert(error);
    }
  }

  render() {
    return (
      <View style={Styles.container}>
        <KeyboardAvoidingView behavior={'height'} style={Styles.modal}>
          <ScrollView keyboardShouldPersistTaps='always'>
            <View>
              {this.state.words == null &&
                <View style={Styles.container}>
                  <KeyboardAvoidingView behavior={'height'} style={Styles.modal}>
                    <ScrollView keyboardShouldPersistTaps='always'>
                      <Autocomplete
                        style={{padding: 10, marginTop: 10, marginLeft: 10, marginRight: 10,
                          height: 40, borderColor: 'gray', borderWidth: 1}}
                        inputContainerStyle={{borderWidth: 0}}
                        listStyle={{paddingLeft:10, paddingRight: 10, marginLeft: 10, marginRight: 10,
                          height: 110, borderColor: 'gray', borderWidth: 1}}
                        onChangeText={this._getSources}
                        value={this.state.source}
                        placeholder="Source"
                        autoCapitalize='none'
                        returnKeyType='next'
                        onSubmitEditing={() => this.textInputCards.focus()}
                        data={this.state.sources}
                        hideResults={this.state.sourcesHide}
                        renderItem={({item, index, separators}) => (
                          <TouchableOpacity onPress={() => this.setState({sourcesHide: true, source: item})}
                            style={{backgroundColor: 'rgba(0,0,0,0)'}}>
                            <Text>{item}</Text>
                          </TouchableOpacity>
                      )}/>
                      <TextInput
                        style={Styles.input}
                        onChangeText={(text) => this.setState({cards: text})}
                        value={this.state.cards}
                        placeholder="Number of cards"
                        autoCapitalize='none'
                        keyboardType='numeric'
                        returnKeyType='done'
                        onSubmitEditing={this.start.bind(this)}
                        ref={(input) => this.textInputCards = input}/>
                      <Text style={{margin: 10}}>You will be shown a definition and have 30 seconds to say the correct word.</Text>
                      <View style={{padding: 10}}>
                        <Button
                          onPress={this.start.bind(this)}
                          title="Start"
                          color="#841584"
                          accessibilityLabel="start"/>
                      </View>
                      <View style={{height: 40}}></View>
                    </ScrollView>
                  </KeyboardAvoidingView>
                </View>
              }
              {this.state.words != null && this.state.message == "" &&
                <View>
                  <Text style={{fontSize: 16, marginLeft: 10, marginRight: 10, marginTop: 20}}>
                    Select the correct word!
                  </Text>
                  <Text style={{fontSize: 14, marginLeft: 10, marginRight: 10, marginTop: 20}}>
                    Definition: {this.state.words[this.state.current].definition}
                  </Text>
                  <Text style={{fontSize: 14, marginLeft: 10, marginRight: 10, marginTop: 10}}>
                    Source: {this.state.words[this.state.current].source}
                  </Text>
                  <Text style={{fontSize: 14, marginLeft: 10, marginRight: 10, marginTop: 10}}>
                    Time left: {this.state.seconds}
                  </Text>
                  {
                    this.state.choices.map((value, key) => {
                      const word = this.state.words[value].word;
                      return (
                        <View style={{padding: 10}}>
                          <Button
                            onPress={() => this.choiceSelected(value)}
                            title={word}
                            color="#841584"
                            accessibilityLabel={word}>{word}</Button>
                        </View>
                      );
                    })
                  }
                </View>
              }
              {this.state.words != null && this.state.message != "" &&
                <View>
                  <Text style={{fontSize: 14, marginLeft: 10, marginRight: 10, marginTop: 20}}>
                    {this.state.message}
                  </Text>
                  <Button
                    onPress={this.next.bind(this)}
                    title="Next"
                    color="#841584"
                    accessibilityLabel="next"/>
                </View>
              }
            </View>
            <View style={{height: 40}}></View>
          </ScrollView>
        </KeyboardAvoidingView>
      </View>
    );
  }
}
